import React from 'react';
type CutoutFrameProps = {
  label: string;
  className?: string;
  children: React.ReactNode;
};

/** A cropped "screenshot" of a piece of the PreForm UI, drawn with the live design tokens. */
export function CutoutFrame({
  label,
  className = '',
  children
}: CutoutFrameProps) {
  return <figure aria-label={`Preview: ${label}`} className={`select-none overflow-hidden rounded-[6px] border border-[#c3c7cc] bg-pf-canvas shadow-[0_8px_24px_rgba(20,28,38,0.18),0_1px_2px_rgba(20,28,38,0.12)] ${className}`} data-id="element-954" data-mp="vwb133msrv5k">
      
      {children}
    </figure>;
}